import { useContext } from "react";
import AlertContext, { AlertContextType } from "./AlertContext";

export const useAlertContext = (): AlertContextType => {
     const context = useContext(AlertContext);
     if (!context) {
          throw new Error('useAlertContext deve ser usado dentro de AlertProvider');
     }
     return context;
};